import {getRememberedOrganization} from './remembered-organization.utils';

import type {LoginContext} from './login-params.utils';

export type AuthMode = 'member' | 'guest';

/** Everything a guest does lives under this path; every other path is a member's. */
export const GUEST_BASE_PATH = '/guest';

/** The mode a page's URL asks for, so each tab keeps its own. */
export function getAuthModeFromPath(pathname = window.location.pathname): AuthMode {
  return pathname === GUEST_BASE_PATH || pathname.startsWith(`${GUEST_BASE_PATH}/`)
    ? 'guest'
    : 'member';
}

/** The mode this page loads in: a guest path, and a guest Auth0 client to sign in with. */
export function resolveAuthMode(guestClientId: string | undefined): AuthMode {
  return guestClientId && getAuthModeFromPath() === 'guest' ? 'guest' : 'member';
}

/** The guest app's absolute URL, where Auth0 returns a guest after login and logout. */
export function getGuestAppUrl(): string {
  return `${window.location.origin}${GUEST_BASE_PATH}`;
}

/** The email an invite link carries (`/guest?email=`), so the first login screen opens with it filled in. */
export function getGuestLoginHint(): string | undefined {
  return new URLSearchParams(window.location.search).get('email') ?? undefined;
}

export function getLoginContext(mode: AuthMode): LoginContext {
  return mode === 'guest'
    ? {kind: 'guest', loginHint: getGuestLoginHint()}
    : {kind: 'member', organization: getRememberedOrganization()};
}
